export const config = {
  isWindows: /win/i.test(window.navigator.platform),
  backupFont: '"Times New Roman"',
}
